import React from 'react';
import { qualifyLink } from '@ace/react-utilities';
import buttonStyles from 'assets/css/Button.module.css';

export const CardLinkIconWrap = ({children}) => {
    if (children) {
        return (
            <span className={buttonStyles.iconWrap}>
                {children}
            </span>
        )
    }
    return false;
}

export function withCardLinkIconWrap(Component) {
    function WithCardLinkIconWrap(props) {
        if (Component) {
            return (
                <span className={buttonStyles.iconWrap}>
                    <Component {...props} />
                </span>
            )
        }

        return false;
    }

    return WithCardLinkIconWrap;
}

const CardLink = (props) => {
    if (props.hasOwnProperty("linkText")) {
        return (
            <div>
                <a href={qualifyLink(props.linkUrl)} className={props.className} target={props.target} style={props.style}>
                    <span dangerouslySetInnerHTML={{__html: props.linkText}} />
                    {props.linkIcon && <CardLinkIconWrap>{props.linkIcon}</CardLinkIconWrap>}
                </a>
            </div>
        )
    }
    return false;
}

export default CardLink;
